import gsap from 'gsap';

import SitelNavs from './nav/main';
import Ytb from './ytb/main';
import FigureZoom from './zoom/main';
import ScrollAnime from './anime/_scroll';


export default class Main{

    constructor(){
        this._init();
    }


    _init(){
        this.navs = new SitelNavs();
        this.ytb = new Ytb();
        this.zoom = new FigureZoom();
        this.scroll = new ScrollAnime();
        this._setSmoothScroll();
    }


    /**
     * smooth scroll
     */
    _setSmoothScroll(){
        const links = document.querySelectorAll('a.js-smooth');
        
        for(let i=0; i<links.length; i++){
            const $a = links[i];
			$a.addEventListener('click', (e)=>{
				e.preventDefault();
				const $target = document.querySelector($a.getAttribute('href'));
                if(!$target) return false;
                
                const adjust = parseInt($target.getAttribute('data-adjust'));
                const targetAdjust = adjust ? adjust : 0;
				const targetPos = parseInt(this._getAbsoluteTop($target)) - targetAdjust;
				gsap.to([document.querySelector("html"),document.querySelector("body")], {duration:0.7, scrollTop:targetPos, ease:'power2.out'});
			});
        }
    }

    _getAbsoluteTop(_selector){
        return _selector.getBoundingClientRect().top + window.pageYOffset;
    }
}
